<template>
    <div class="groups">
       <default-group :default-group="defaultGroup" :first-group="firstGroup"></default-group>
            <draggable v-model="groups" group="groups" @start="drag=true" @end="drag=false" handle=".handle">
                <div
                    v-for="(group, index) in groups"
                    :key="`group${index}`"
                    class="group-item"
                >
                    <group
                        :group="group"
                        :index="index"
                        :blocks="group.blocks"
                    >
                    </group>
                    <div class="group-btn">
                        <v-btn @click="openDeleteDialog(group)" fab small color=""><v-icon color="#666">delete_outline</v-icon></v-btn>
                        <v-btn  class="handle" fab small color=""><v-icon color="#666">height</v-icon></v-btn>
                    </div>
                </div>
            </draggable>
        <v-dialog
                v-model="dialog"
                width="500"
        >
            <delete-dialog
                    :title="`group ${toDelete.title}`"
                    @closeDialog="dialog = false"
                    @onDelete="deleteGroup"
            ></delete-dialog>
        </v-dialog>
        <div class="text-xs-center">
            <v-btn
                    large round flat
                    class="text-gray x-large-button"
                    @click="addNewGroup"
            >
                <v-icon>add_circle_outline</v-icon>
                Add Group
            </v-btn>
        </div>
    </div>
</template>

<script>
    import common from "../../../utils/common"
    import defaultGroup from './default-group'
    import group from './group'
    import _ from 'lodash'
    import draggable from 'vuedraggable'
    import deleteDialog from '../../common/deleteDialog'
    export default {
        name: "groups",
        components: {
            defaultGroup,
            group,
            draggable,
            deleteDialog
        },
        data() {
            return {
                groups: [],
                defaultGroup:[],
                firstGroup:[],
                toDelete: "",
                dialog: false
            }
        },
        mounted(){
            this.getGroups()
            this.getDefaultGroup()

        },
        methods: {
            getGroups() {
                this.$http_bot('/groups')
                    .then(response=>{
                        this.groups = response.data
                        for (let i=0; i<this.groups.length; i++) {
                            if (this.groups[i].blocks === null) {
                                this.groups[i].blocks = []
                            }
                        }
                    })
                    .catch(error=>{
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            getDefaultGroup() {
                this.$store.dispatch('setLoader',true)
                this.$http_bot(`/blocks?group_id=0`)
                    .then(response=>{
                        this.$store.dispatch('setLoader',false)
                        for (let i=0; i<response.data.length; i++) {
                            if (response.data[i].slug === 'welcome-message' || response.data[i].slug === 'default-message') {
                                this.defaultGroup.push(response.data[i])
                            } else {
                                this.firstGroup.push(response.data[i])
                            }
                        }
                        this.$store.dispatch('setSelectedBlock',this.defaultGroup[0])
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            getBlocks() {
                this.$store.dispatch('setLoader',true)
                this.$http_bot('/blocks')
                    .then(response=>{
                        this.$store.dispatch('setLoader',false)
                        for (let i=0; i<response.data.length; i++){
                            if (response.data[i].group_id === 0 ) {
                                if (response.data[i].name === 'Welcome Message' || response.data[i].name === 'Default Message') {
                                    this.defaultGroup.push(response.data[i])
                                } else {
                                    this.firstGroup.push(response.data[i])
                                }
                            } else {
                                let index = _.findIndex(this.groups,o=>{
                                    return response.data[i].group_id === o.id
                                })
                                this.groups[index].blocks.push(response.data[i])
                            }
                        }
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            addNewGroup() {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post(`/groups?bot_id=${this.botId}`,{
                    bot_id: this.botId,
                    order: this.groups.length+1,
                    title: `New Group ${this.groups.length+1}`
                })
                    .then(response=>{
                        this.$store.dispatch('setLoader',false)
                        this.groups.push(response.data)
                        this.$store.dispatch('setSavingStatus', false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            openDeleteDialog(group) {
                this.dialog = true
                this.toDelete = group
            },
            deleteGroup() {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.delete(`/groups/${this.toDelete.id}`)
                    .then(response=>{
                        this.$store.dispatch('setLoader',false)
                        this.$store.dispatch('setSavingStatus', false)
                        this.dialog = false
                        let index = _.findIndex(this.groups, o=> {
                            return this.toDelete.id === o.id
                        })
                        this.groups.splice(index,1)
                        this.toDelete = {}
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            deleteBlock() {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                let index = -1
                let groupIndex = -1
                this.$http.delete(`/blocks/${this.deletedBlock.id}`)
                    .then(response=>{
                        if (this.deletedBlock.group_id === 0) {
                            index = _.findIndex(this.firstGroup, o=>{
                                return o.id === this.deletedBlock.id
                            })
                            this.firstGroup.splice(index,1)
                            this.$store.dispatch('setSelectedBlock',this.firstGroup[this.firstGroup.length-1])
                        } else {
                            groupIndex = _.findIndex(this.groups, o=>{
                                return o.id === this.deletedBlock.group_id
                            })
                            index = _.findIndex(this.groups[groupIndex].blocks , o=>{
                                 return o.id === this.deletedBlock.id
                            })
                            this.groups[groupIndex].blocks.splice(index,1)
                            this.$store.dispatch('setSelectedBlock',this.groups[groupIndex].blocks[this.groups[groupIndex].blocks.length-1])
                        }
                        this.$store.dispatch('setDeletedBlock',{})
                        this.$store.dispatch('setLoader',false)
                        this.$store.dispatch('setSavingStatus', false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            }
        },
        computed: {
            botId() {
                return this.$store.state.bot.botId
            },
            deletedBlock() {
                return this.$store.state.blocksBuild.deletedBlock
            }
        },
        watch: {
            deletedBlock(state) {
                if (state.id) {
                    this.deleteBlock()
                }
            }
        }
    }
</script>

<style scoped>

</style>